import React from 'react';

/**
 * Top Vulnerabilities chart component - list showing vulnerabilities by risk level
 * @param {Object} props
 * @param {Array} props.data - Array of {title, risk_x_asset, classification}
 */
export default function TopVulnerabilitiesChart({ data = [] }) {
  if (data.length === 0) {
    return (
      <div className="text-center py-8 text-slate-500 text-sm">
        No vulnerability data available
      </div>
    );
  }

  // Color coding based on classification
  const getClassificationColor = (classification) => {
    const cls = (classification || '').toLowerCase();
    if (cls === 'critical') return '#dc2626'; // red
    if (cls === 'high') return '#fb923c'; // orange
    if (cls === 'moderate') return '#facc15'; // yellow
    if (cls === 'low') return '#38bdf8'; // sky blue
    return '#94a3b8'; // slate
  };

  const getClassificationBg = (classification) => {
    const cls = (classification || '').toLowerCase();
    if (cls === 'critical') return 'bg-red-100 text-red-900';
    if (cls === 'high') return 'bg-orange-100 text-orange-900';
    if (cls === 'moderate') return 'bg-amber-100 text-amber-900';
    if (cls === 'low') return 'bg-sky-100 text-sky-800';
    return 'bg-slate-100 text-slate-700';
  };

  return (
    <div className="w-full">
      <div className="space-y-1.5">
        {data.map((vuln, idx) => {
          const classification = vuln.classification || 'Info';
          const risk = vuln.risk_x_asset || 0;

          return (
            <div key={`${vuln.title}-${idx}`} className="flex items-center gap-3 px-2.5 py-2 rounded-lg hover:bg-slate-50 transition-colors">
              <span className={`inline-flex px-2 py-0.5 rounded-full text-[10px] font-bold flex-shrink-0 ${getClassificationBg(classification)}`}>
                {classification}
              </span>
              <div className="flex-1 min-w-0 text-xs font-medium text-slate-600 truncate" title={vuln.title}>
                {vuln.title}
              </div>
              <span className="text-xs font-bold text-slate-400 tabular-nums flex-shrink-0">
                {risk.toFixed(1)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
